// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#fm-toolbar-wrapper #fm-toolbar li#fm-tab-fullscreen {\n  width: 75px;\n}\n\n#fm-toolbar-wrapper #fm-toolbar li {\n  width: 75px;\n}", ""]);
// Exports
module.exports = exports;
